import React, { Component } from 'react';
import DattoEDRSpinner from 'common/icons/DattoEDRSpinner';

import './logo-spinner.scss';

class LogoSpinner extends Component {
    render() {
        return (
            <div className={'logo-spinner__container'}>
                <DattoEDRSpinner className="c-icon--container-large kds-spinner" />
            </div>
        );
    }
}

LogoSpinner.propTypes = {};

LogoSpinner.defaultProps = {};

export default LogoSpinner;
